
import formatDate from "./date"
import formatDateHumanize from "./date-humanize"

export default function formatDateShort(date: Moment, humanize:boolean = true):string {

    // date is a moment object here

    if (!date) return ''

    // convert to Moment if not moment
    if (!moment.isMoment(date)) {
        date = moment(date)
    }

    const format: string = (date.year()===moment().year()) ? 'MMM D' : 'MMM D, YYYY'
    // const format: string = (date.year()===Moment().year()) ? 'D MMM' : 'D MMM, YYYY'

    if (humanize) {
        return formatDateHumanize(date, format)
    } else {
        return formatDate(date, format)
    }
}
